import { getDatadogRumOptions, initializeDatadogRum } from "./datadog";
import { LoadOptions } from "./global";
import { load } from "./load";

export function init() {
  const options = {
    apiHost: process.env.REACT_APP_API_BASE_URL || "https://api.sendgrid.com",
  } as LoadOptions;
  const datadogRum = getDatadogRumOptions();
  try {
    load(options);
    if (datadogRum) {
      initializeDatadogRum(datadogRum);
    }
  } catch (error) {
    console.error("Failed to initialize analytics", error);
  }
}
